import React, { useState, useContext } from 'react';
import {LegacyStack, Link} from '@shopify/polaris';
import { SubscriptionsContext } from '../../contexts/Subscriptions'
import { ProductsContext } from '../../contexts/Products'
import Productable from '../../concerns/Productable'

export default function UpgradeFreeTrial(props) {
  const subscriptions = useContext(SubscriptionsContext)
  const [products] = useContext(ProductsContext)

  const subscription = subscriptions.find((s) => s.id == props.subscription_id)

  const variant = Productable.variant(products, subscription)

  return (
    <form id="registration-form" action="/cart/add" method="post">
      <input type="hidden" name="id" value={variant.id} />
      <input type="hidden" name="properties[_enrollment_to_upgrade]" value={subscription.enrollmentId} />
      <input type="submit" className={props.submitClassName || 'button'} value="Upgrade" />
    </form>
  );
}
